import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { useIntl } from 'react-intl';
import { TranslationKeys } from 'app/translations';

type SuccessStepProps = {
  onReset: () => void;
};

export const SuccessStep = ({ onReset }: SuccessStepProps) => {
  const intl = useIntl();

  return (
    <Box sx={{ textAlign: 'center', py: 6 }}>
      <FontAwesomeIcon icon={faCheck} size="3x" color="#40C484" />
      <Typography variant="h6" sx={{ mt: 2 }}>
        {intl.formatMessage({ id: TranslationKeys.adminPanel_bulkLeftCompany_submitSuccess })}
      </Typography>
      <Button sx={{ mt: 3 }} variant="outlined" onClick={onReset}>
        {intl.formatMessage({ id: TranslationKeys.adminPanel_bulkLeftCompany_step_upload })}
      </Button>
    </Box>
  );
};
